






































































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { accountModule } from '@app/utils/store-accessor'
import { AvailableLang, Lang } from '@app/types/src/Lang'
export default defineComponent({
  name: 'LangSwitch',
  setup() {
    const showPanel = ref(false)
    const langSelect = ref()
    const langPanel = ref()
    const togglePanel = () => {
      showPanel.value = !showPanel.value
      if (showPanel.value) {
        // 要素外をクリックしたら閉じる
        document.addEventListener('click', clickOutside)
      }
    }
    const clickOutside = (e: any) => {
      if (
        !langSelect.value?.contains(e.target) &&
        !langPanel.value?.contains(e.target)
      ) {
        hidePanel()
      }
    }
    const hidePanel = () => {
      showPanel.value = false
      document.removeEventListener('click', hidePanel)
    }

    const label = computed(() => {
      switch (accountModule.language) {
        case 'JP':
          return '日本/日本語'
        case 'KR':
          return '대한민국/한국어'
        case 'TW':
          return '台灣/繁體中文'
        case 'HK':
          return '香港/香港繁体字'
        case 'EN':
          return 'Other/English'
        case 'VN':
          return 'Việt Nam/Tiếng Việt'
        default:
          return '日本/日本語'
      }
    })

    const changeLang = (lang: Lang) => {
      hidePanel()
      accountModule.setLanguage(lang)
    }

    const showLangSwitch = computed(() => {
      return accountModule.language !== AvailableLang.EN
    })
    return {
      showPanel,
      togglePanel,
      changeLang,
      langSelect,
      langPanel,
      label,
      showLangSwitch,
    }
  },
})
